import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { ENROLLMENT_APP_STATE_NAME, saveApplicationSubmissionInfo } from '../../../../../shared/reducers/enrollmentApp.reducer';
import { EnrollmentSubmissionService } from '../enrollment-submission.service';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { EnrollmentAppStateStructure } from '../../../interfaces/enrollmentAppStateStructure.interface';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { EnrollPayloadRequest, EnrollPayloadSubmitRequest, EnrollPayloadSaveRequest } from '../../../interfaces/enrollment-submission.interface';
import { WholeHealthBalanceCrosswalk } from 'src/app/angular-elements/shared/components/configs/interfaces/whole-health-balance-and-agent-cube-state-structure.interface';
import { ProducerStateStructure } from 'src/app/angular-elements/producer/configs/interfaces/producerStateStructure.interface';
import { AgentInfo } from '../../../interfaces/agent-info.interface';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, LoggedInUserInformationService, RegistrationService, LINE_OF_BUSINESS_ENUM, BaseAgency } from '@ptl/account-management';
import { GlobalDataStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/globalStateStructure.interface';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { MedicareAdvantage_and_PDP_Product, Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { PRODUCT_GROUPS, PRODUCT_TYPES } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { PrePopulatedDataStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/prePopulatedDataStateStructure.interface';
// import * as _moment from 'moment';
import type { Moment } from 'moment';
// const moment = _moment;
import moment from 'moment';
import { LoginPageComponent } from 'src/app/angular-elements/shared/components/login-page/login-page.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PtlWindowLocationService, CountyListService } from '@ptl/global-components';
import { BasicUserInfo } from '@ptl/account-management';
import { DateService } from 'src/app/shared/services/date.service';
import { ConfirmationPageUrls } from 'src/app/angular-elements/shared/components/interfaces/confirmation-page-urls.interface';
import { FormError } from 'src/app/angular-elements/shared/components/interfaces/form-error.interface';
import { PlanUtilityService } from 'src/app/angular-elements/plan-selection/plan-summary-list/plan-utility.service';
import { EnrollmentSubmissionMedigapService } from './product-type-validation/enrollment-submission.medigap.service';
import { EnrollmentSubmissionWHBService } from './product-type-validation/enrollment.submission.whb.service';
import { EnrollmentSubmissionMAService } from './product-type-validation/enrollment-submission.medicare-adv.service';
import { EnrollmentSubmissionPDPService } from './product-type-validation/enrollment-submission.pdp.service';
import { UserInfoService } from '../../user-info.service';
import { BrandingConfigurationService } from '@ptl/brand';
import { setEffectiveDate } from '../../../components/configs/reducers/effective-date.reducer';
import { EffectiveDateStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/effective-date.state-structure.interface';
import { DRXStateStructure } from '../../../../medical-information/medication-information/reducers/drx-response.reducer';
import { DrxService } from '../../../../medical-information/medication-information/services/drx.service';
import { planDetailsByPlanId } from '../../../../plan-selection/configs/reducers/plan-details.reducer';
import { PLAN_STATE_NAME, selectPlanForDRX } from '../../../../plan-selection/configs/reducers/plans.reducer';
import { MedigapRequiredDocumentUploadStateStructure, MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME } from 'src/app/angular-elements/form-wrappers/form-components/required-docs-upload/medigap-form.doc-upload.reducer';
import { ProducerChangeAgencyModalComponent } from '../../../../producer/producer-change-agency/producer-change-agency-modal/producer-change-agency-modal.component';
import { LOB_STATE_NAME } from '../../../components/configs/reducers/lob.reducer';
import { ZIP_COUNTY_STATE_NAME } from '../../../../demographics/zip-county-modal/reducers/zipCounty.reducer';
import { PRODUCER_STATE_NAME } from '../../../../producer/configs/reducers/producer.reducer';
import { WHOLE_HEALTH_BALANCE_CROSSWALK_STATE_NAME } from '../../../components/configs/reducers/whb-crosswalk.reducer';
import { DOCTOR_VENDOR_TYPE } from 'src/app/angular-elements/medical-information/doctor-information/configs/enums/doctor-vendor-type.enum';
import { DoctorStateSapphireDigital, DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL } from 'src/app/angular-elements/medical-information/doctor-information-sapphire-digital/configs/reducers/doctors.reducer';
import { DoctorStateKyruus, DOCTOR_STATE_REDUX_ID_KYRUUS } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/reducers/doctors.reducer';
import { DoctorVendorTypeState, DOCTOR_VENDOR_TYPE_STATE_REDUX_ID } from 'src/app/angular-elements/medical-information/doctor-information/configs/reducers/doctor-information.reducer';
import { APP_STATUS } from 'src/app/angular-elements/producer/enums/app-status.enum';

@Injectable({
    providedIn: 'root'
})
export class SeniorMarketsEnrollmentSubmissionService {

    productGroup = PRODUCT_GROUPS.MEDICARE_ADVANTAGE;
    productType = 'MA';

    constructor(
        private reducerUtilityService: ReducerUtilityService,
        private userInfoService: UserInfoService,
        private electionQuestionsService: EnrollmentSubmissionService,
        private ngRedux: NgRedux<StateStructure>,
        private planUtilityService: PlanUtilityService,
        private loggedInUserService: LoggedInUserInformationService,
        private matDialog: MatDialog,
        private windowLocationService: PtlWindowLocationService,
        private registrationService: RegistrationService,
        private snackBar: MatSnackBar,
        private dateUtility: DateService,
        private commonUtilityService: CommonUtilityService,
        private medigapSubmitService: EnrollmentSubmissionMedigapService,
        private whbSubmitService: EnrollmentSubmissionWHBService,
        private medicareSubmitService: EnrollmentSubmissionMAService,
        private pdpSubmitService: EnrollmentSubmissionPDPService,
        private drxService: DrxService,
        private brandService: BrandingConfigurationService,
        private countyService: CountyListService
    ) { }

    /** PRODUCT AGNOSTIC */
    modifyPhoneNumber = (val: string): string => {
        if (val) {
            let result = val.replace(/[^0-9]/g, '');
            if (result.length > 10) {
                result = result.substring(0, 10);
            }
            return result;
        }
    }

    private applyMedigapFieldsToPayload(payload: any, planState: PlansStateStructure) {
        if (planState.medigapValuesPostFormSubmit) {
            payload.enrollment.gender = planState.medigapValuesPostFormSubmit.gender;
            payload.enrollment.macra = planState.medigapValuesPostFormSubmit.macra;
            payload.enrollment.whb = planState.medigapValuesPostFormSubmit.whb
            payload.enrollment.tobaccoUsage = planState.medigapValuesPostFormSubmit.tobaccoUsage;
            payload.enrollment.dob = planState.medigapValuesPostFormSubmit.dob;
            payload.enrollment.coverageDate = planState.medigapValuesPostFormSubmit.coverageDate;
            payload.enrollment.hardStops = planState.medigapValuesPostFormSubmit.hardStops;
        }
    }

    private async generateEnrollmentSubmissionPayload(isPlanChange: boolean, isSimplifiedEnrollment: boolean): Promise<EnrollPayloadRequest> {
        /** Payload States */
        const payloadState = JSON.parse(JSON.stringify(this.reducerUtilityService.getPayloadStates()));

        if (!payloadState.enrollment) {
            payloadState.enrollment = {};
        }

        /** Component States */
        const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState(ZIP_COUNTY_STATE_NAME);
        const planState: PlansStateStructure = this.reducerUtilityService.getState(PLAN_STATE_NAME);

        const whbAndAgentCubeState: WholeHealthBalanceCrosswalk = this.reducerUtilityService.getState(WHOLE_HEALTH_BALANCE_CROSSWALK_STATE_NAME);
        const producerInfo: ProducerStateStructure = this.reducerUtilityService.getState(PRODUCER_STATE_NAME);
        const globalData: GlobalDataStateStructure = this.reducerUtilityService.getState('GlobalData');

        const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

        this.getHighLevelStateObjects(payloadState);

        const effectiveDateState: EffectiveDateStateStructure = this.reducerUtilityService.getReducerFromApplicationState('EffectiveDate');
        const effectiveDateYear = effectiveDateState?.effectiveDateYear;
        const effectiveDateYearAsNum = Number(effectiveDateYear);

        if (effectiveDateYearAsNum !== 2022) {
            delete payloadState.dentalInfo;
        }

        // Medications
        let medForm = payloadState.MedigapEnrollmentMedications && payloadState.MedigapEnrollmentMedications.medicationForm;
        if (medForm) {
            // Only include medications if they have them, or always for WY since they don't have that question
            if ((medForm.isPrescribedMeds === 'Yes' || zipcountyState.county.region == 'WY') && medForm.medications) {
                payloadState.medications = medForm.medications;
            }

            payloadState.isPrescribedMeds = medForm.isPrescribedMeds;
            delete payloadState.MedigapEnrollmentMedications;
        }

        this.getInsuranceInfoStateValues(payloadState);
        /**
         * Filter the active product groups by the selected product ID to get relevant values
         */
        const plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();
        const productInfo = {
            planId: null,
            planName: null,
            cmsPlanID: null,
            pbpId: null,
            segmentId: null,
            groupNo: null,
            newGroupNo: null,
            superProductId: null,
            monthlyPremium: null,
            planDetails: null,
            drxSingleProductResponse: null
        };

        try {
            const selectedPlan: Product<PlanAttributes, SummaryView> =
                plansFromState.filter(plan => plan.attributes.PLAN_ID === planState.planIdForEnrollment)[0];

            /** ARCHIVAL PLAN-DETAILS TO BE STORED - not read on backend */
            productInfo.planDetails = selectedPlan;

            // Single-Attributes, specifically named - actually read on backend

            /** Product Info */
            productInfo.planId = selectedPlan.attributes.PLAN_ID;
            productInfo.planName = selectedPlan.attributes.PRODUCT_NAME;
            productInfo.cmsPlanID = selectedPlan.attributes.CMS_PLAN_ID;
            productInfo.pbpId = selectedPlan.attributes.PBP_ID;
            productInfo.segmentId = selectedPlan.attributes.SEGMENT_ID;
            productInfo.superProductId = selectedPlan.attributes.SUPER_PRODUCT_ID;
            productInfo.monthlyPremium = selectedPlan.price;

            productInfo.drxSingleProductResponse = await this.getDrxData(selectedPlan);

        } catch (e) {
            /** In WHB flow, we don't need this data, but it's worthwhile for checking the flows for upstream (UI) issues */
        }

        /** Whole Health Balance Attributes */
        productInfo.groupNo = whbAndAgentCubeState.whbcrosswalk && whbAndAgentCubeState.whbcrosswalk.oldGroup;
        productInfo.newGroupNo = whbAndAgentCubeState.whbcrosswalk && whbAndAgentCubeState.whbcrosswalk.newGroup;

        // ProductGroup is not consumed on backend, so it doesn't matter what we send
        /** Product Group/Type Info */
        if (planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_ADVANTAGE) {
            this.productGroup = PRODUCT_GROUPS.MEDICARE_ADVANTAGE;
            this.productType = PRODUCT_TYPES.MEDICARE_ADVANTAGE;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN) {
            this.productGroup = PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN;
            this.productType = PRODUCT_TYPES.PRESCRIPTION_DRUG_PLAN;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.MEDIGAP
            || planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT) {
            this.productGroup = PRODUCT_GROUPS.MEDIGAP;
            this.productType = PRODUCT_TYPES.MEDIGAP;
            this.applyMedigapFieldsToPayload(payloadState, planState);
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
            this.productGroup = PRODUCT_GROUPS.MEDIGAP;
            this.productType = PRODUCT_TYPES.WHOLE_HEALTH_BALANCE;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.OFF_EXCHANGE) {
            this.productGroup = PRODUCT_GROUPS.OFF_EXCHANGE;
            this.productType = PRODUCT_TYPES.OFF_EXCHANGE;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.DENTAL) {
            this.productGroup = PRODUCT_GROUPS.DENTAL;
            this.productType = PRODUCT_TYPES.DENTAL;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.BLUE_EDGE_BALANCE) {
            this.productGroup = PRODUCT_GROUPS.BLUE_EDGE_BALANCE;
            this.productType = PRODUCT_TYPES.BLUE_EDGE_BALANCE;
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.DSNP) {
            this.productGroup = PRODUCT_GROUPS.DSNP;
            this.productType = PRODUCT_TYPES.DSNP;
        }

        if (isPlanChange) {
            this.productType = this.productType + PRODUCT_TYPES.PLAN_CHANGE_SUFFX;
            this.getPrepopulatedDataForPlanChange(payloadState);
        }

        if (isSimplifiedEnrollment) {
            // TODO: PLANSUMMARY: Get this configuration from contentStorage instead.
            this.productType = this.productType + PRODUCT_TYPES.SIMPLIFIED_SUFFIX;
            payloadState.enrollment.effectiveDate = moment().add(1, 'months').startOf('month').format('MM/DD/YYYY');

            if (payloadState && payloadState.enrollment) {
                payloadState.enrollment.currentlyEnrolledMAOther = 'No';
                payloadState.enrollment.currentlyMedicaidRecipient = 'No';
                payloadState.enrollment.employedStatus = 'Not Applicable';
                payloadState.enrollment.spouseEmployedStatus = 'Not Applicable';
                payloadState.enrollment.applicant = 'enrollee';
                delete payloadState.enrollment.saveElectionAppIn;
                payloadState.enrollment.saveElectionAppIn = [{
                    electionCode: 'I',
                    finalIndicator: false,
                    proposedEffectiveDate: [],
                    questionInsertDate: null,
                    questionNumber: '01',
                    questionValidIndicator: false
                }];
            }
        }

        /** User Info */
        let agentData: AgentInfo;
        let userType = 'CR';

        if (this.commonUtilityService.isAgent()) {
            //TODO: review logic from common-utility.service.ts in function getEnrollmentFormType
            const isTelesalesFlow = this.loggedInUserService.isMedicareTelesales() && !this.commonUtilityService.isFieldAgentAsProducer();

            if (isTelesalesFlow) {
                userType = 'TA';
            } else {
                userType = 'PR';
            }
            let npnNo = producerInfo.selectedAgency.npnNo;
            if (!npnNo) {
                npnNo = globalData && globalData.urlParams && globalData.urlParams.agentCode;
            }
            let agencyID = producerInfo.selectedAgency.agencyId;
            if (!agencyID) {
                agencyID = globalData && globalData.urlParams && globalData.urlParams.agencyNumber;
            }

            agentData = {
                producerReferredAppInd: 'N',
                firstName: loginInfo.userInfo.firstName,
                middleName: loginInfo.userInfo.middleInitial,
                lastName: loginInfo.userInfo.lastName,
                producerId: npnNo,
                producerNumber: npnNo,
                agencyNumber: agencyID,
                agencyId: agencyID,
                npnNumber: npnNo,
                agencyName: producerInfo.selectedAgency.agencyName,
                businessPhone: null,
                email: loginInfo.userInfo.email,
                producerUserId: npnNo,
                phoneNumber: parseInt(loginInfo.userInfo.telephone)
            };
        } else {
            const npnNo = globalData && globalData.urlParams && globalData.urlParams.agentCode;
            const agencyID = globalData && globalData.urlParams && globalData.urlParams.agencyNumber;
            agentData = {
                producerReferredAppInd: 'N',
                firstName: '',
                middleName: '',
                lastName: '',
                producerId: npnNo,
                producerNumber: npnNo,
                agencyNumber: agencyID,
                agencyId: agencyID,
                npnNumber: npnNo,
                agencyName: '',
                businessPhone: '',
                email: '',
                producerUserId: '',
                phoneNumber: null
            };
        }

        if (payloadState.medigapEligibilityCheck) {
            this.medigapSubmitService.getEligibilityCheckStateInfo(payloadState);
            this.medigapSubmitService.setDocumentValues(payloadState, planState.activeProductGroup);
        }

        if (payloadState.medigapEnrollmentMedications && payloadState.medigapEnrollmentMedications.medicationForm.medications) {
            this.medigapSubmitService.getMedicationsStateInfo(payloadState);
        }

        payloadState.submitStatus = 'SUBMITTED';
        payloadState.ubk = zipcountyState.county.ubk;
        
        // Use the saved zip code to pull the brand value since alternate windows can disrupt the cookies
        payloadState.ddValue = this.brandService.getBrandFromCookieCode(zipcountyState.county.brand).ddToken;

        payloadState.productType = this.productType;
        payloadState.productDescription = this.productGroup;

        const electionQuestionState: EnrollmentAppStateStructure = this.reducerUtilityService.getState('EnrollmentApp');
        payloadState.enrollment.saveElectionAppIn = electionQuestionState.saveElectionAppIn;

        payloadState.enrollment.productData = productInfo;
        payloadState.enrollment.userType = userType;
        payloadState.enrollment.partAEffectiveDate = this.dateUtility.getNullOrFormattedDate(payloadState.enrollment.partAEffectiveDate, 'MM/DD/YYYY');
        payloadState.enrollment.partBEffectiveDate = this.dateUtility.getNullOrFormattedDate(payloadState.enrollment.partBEffectiveDate, 'MM/DD/YYYY');
        payloadState.enrollment.userId = loginInfo.userId;

        this.setDateOrRemoveKey(payloadState.enrollment, 'spouseRetiredDate');
        this.setDateOrRemoveKey(payloadState.enrollment, 'spouseHasRetiredDate');
        this.setDateOrRemoveKey(payloadState.enrollment, 'willRetiredDate');
        this.setDateOrRemoveKey(payloadState.enrollment, 'haveRetiredDate');

        if (payloadState?.applicantInfo) {
            if (payloadState.applicantInfo.howIsAppBeingEntered === 'Paper Application Previously Received') {
                payloadState.enrollment.submissionChannel = 'P';
            }
            else {
                payloadState.enrollment.submissionChannel = 'W';
            }

            if (payloadState.applicantInfo.applicationReceivedDate) {
                payloadState.applicantInfo.applicationReceivedDate = this.dateUtility.getDateAsFormattedString(payloadState.applicantInfo.applicationReceivedDate, 'MM/DD/YYYY');
            }
        }

        payloadState.enrollment.coverageDate = this.dateUtility.getValidCoverageDate(payloadState.enrollment.coverageDate);

        // Adding pcp info
        const doctorVendorState: DoctorVendorTypeState = this.reducerUtilityService.getState(DOCTOR_VENDOR_TYPE_STATE_REDUX_ID);
        if (doctorVendorState.vendorType === DOCTOR_VENDOR_TYPE.SAPPHIRE_DIGITAL) {
            const doctorState: DoctorStateSapphireDigital = this.reducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL);
            if (doctorState && doctorState.pcp) {
                payloadState.enrollment.pcpPracticeNumber = doctorState.pcp.fivePartKey_providerId;
                payloadState.enrollment.pcpPracticeName = doctorState.pcp.name;
            }
    
            if (payloadState.enrollment.currentlyPatientOfPcp) {
                payloadState.enrollment.currentlyPatientOfPcp = 'Yes';
            }
            else {
                delete payloadState.enrollment.currentlyPatientOfPcp;
            }
        } else if (doctorVendorState.vendorType === DOCTOR_VENDOR_TYPE.KYRUUS) {
            const doctorState: DoctorStateKyruus = this.reducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_KYRUUS);
            if (doctorState && doctorState.pcp) {
                payloadState.enrollment.pcpPracticeNumber = doctorState.pcp.fivePartKey_providerId;
                payloadState.enrollment.pcpPracticeName = doctorState.pcp.name;
            }
    
            if (payloadState.enrollment.currentlyPatientOfPcp) {
                payloadState.enrollment.currentlyPatientOfPcp = 'Yes';
            }
            else {
                delete payloadState.enrollment.currentlyPatientOfPcp;
            }

        }

        // Adding notice to applicant in payload for NY
        if (payloadState.enrollment?.noticeToApplicant && (zipcountyState.county.region === 'WNY' || zipcountyState.county.region === 'NENY')) {
            this.setDateOrRemoveKey(payloadState.enrollment.noticeToApplicant, 'applicationSignedDate');
        }

        const existingDOB = this.dateUtility.getDateAsFormattedString((payloadState.enrollment.dob || payloadState.personalInfo.dob), 'MM/DD/YYYY');
        const existingGender = payloadState.enrollment.gender || payloadState.personalInfo.gender;

        payloadState.enrollment.gender = existingGender;
        payloadState.enrollment.dob = existingDOB;

        payloadState.personalInfo.gender = existingGender;
        payloadState.personalInfo.dob = existingDOB;


        payloadState.personalInfo.personalPhoneNumber =
            payloadState.personalInfo.personalPhoneNumber &&
            this.modifyPhoneNumber(payloadState.personalInfo.personalPhoneNumber);

        payloadState.personalInfo.facilityPhoneNumber =
            payloadState.personalInfo.facilityPhoneNumber &&
            this.modifyPhoneNumber(payloadState.personalInfo.facilityPhoneNumber);

        payloadState.personalInfo.emergencyContactPhoneNumber =
            payloadState.personalInfo.emergencyContactPhoneNumber &&
            this.modifyPhoneNumber(payloadState.personalInfo.emergencyContactPhoneNumber);


        if (payloadState.authRep) {
            payloadState.authRep.phoneNumber = payloadState.authRep.phoneNumber && this.modifyPhoneNumber(payloadState.authRep.phoneNumber);
        }


        if (payloadState.personalInfo.ssn) {
            payloadState.personalInfo.ssn = payloadState.personalInfo.ssn.replace(/-/g, '');
        }


        payloadState.submitStatus = null;
        if (agentData) {
            for (const [key, value] of Object.entries(agentData)) {
                if (value === '') {
                    delete agentData[key];
                }
            }
        }
        
        payloadState.agentInfo = agentData;
        payloadState.productType = this.productType;
        payloadState.productDescription = this.productGroup;
        
        const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');
        payloadState.opportunityId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.opportunityId;
        payloadState.customerId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.customerId;
        payloadState.salesforceAccountId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.salesforceAccountId;
        payloadState.salesforceOpportunityId = prePopulateData.prepopulatedFields && prePopulateData.prepopulatedFields.salesforceOpportunityId;

        if (this.productType === PRODUCT_TYPES.WHOLE_HEALTH_BALANCE) {
            this.whbSubmitService.getWHBStateInfo(payloadState);

            let curEffectiveDateString = payloadState.enrollment.effectiveDate ? payloadState.enrollment.effectiveDate : this.dateUtility.oneMonthIntoFutureDate();

            // Member flow will not have this populated so we need to go look it up
            if (!prePopulateData.prepopulatedFields.effectiveStartDate) {
                const umi = prePopulateData.prepopulatedFields.memberIdNumber;
                const dob = prePopulateData.prepopulatedFields.dob;
                const res = await this.userInfoService.memberLookup(umi, dob, isPlanChange);
                const memberLookup = res.payload.retrieveApplicationOutput;

                if (memberLookup?.EFFECTIVESTARTDATE) {
                    prePopulateData.prepopulatedFields.effectiveStartDate = memberLookup.EFFECTIVESTARTDATE;
                }
                else {
                    // If we didn't fetch anything fall back to default
                    prePopulateData.prepopulatedFields.effectiveStartDate = this.dateUtility.oneMonthIntoFutureDate();
                }
            }

            // Set effective date to member's current effective date if it is in the future
            let memberEffectiveDate = new Date(prePopulateData.prepopulatedFields.effectiveStartDate);
            let existingEffectiveDate = new Date(curEffectiveDateString);

            // Using date values for comparison, setting the appropriate string date as the actual value
            if (memberEffectiveDate > existingEffectiveDate) {
                payloadState.enrollment.effectiveDate = prePopulateData.prepopulatedFields.effectiveStartDate;
            }
            else {
                payloadState.enrollment.effectiveDate = curEffectiveDateString;
            }

            // Update final effective date in the state for confirmation page use
            this.ngRedux.dispatch(setEffectiveDate(payloadState.enrollment.effectiveDate));
        }

        // Map race and ethnicity checkboxes to arrays of values
        if (this.productGroup === PRODUCT_GROUPS.MEDICARE_ADVANTAGE || this.productGroup === PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN) {
            if (payloadState.personalInfo.raceCodes) {
                payloadState.enrollment.raceCodes = this.convertCodesToArray(payloadState.personalInfo.raceCodes);
                delete payloadState.personalInfo.raceCodes;

                if (!payloadState.enrollment.raceCodes.length) {
                    delete payloadState.enrollment.raceCodes;
                }
            }

            if (payloadState.personalInfo.ethnicityCodes) {
                payloadState.enrollment.ethnicityCodes = this.convertCodesToArray(payloadState.personalInfo.ethnicityCodes);
                delete payloadState.personalInfo.ethnicityCodes;

                if (!payloadState.enrollment.ethnicityCodes.length) {
                    delete payloadState.enrollment.ethnicityCodes;
                }
            }
        }

        // Set the app id if this was a previously saved app
        const enrollState: EnrollmentAppStateStructure = this.reducerUtilityService.getState(ENROLLMENT_APP_STATE_NAME);
        if (enrollState.appId) {
            payloadState.applicationTrackingId = enrollState.appId;
        }

        // Add the referral Id for submit payload
        payloadState.referralid = globalData && globalData.urlParams && globalData.urlParams.referralid;
        return payloadState;
    }

    private convertCodesToArray(codeObject): string[] {
        let results = [];

        Object.keys(codeObject).forEach(key => {
            if (codeObject[key]) {
                results.push(key);
            }
        });

        return results;
    }

    private getHighLevelStateObjects(payloadState) {
        const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState('ZipCounty');

        const enrollmentData = payloadState.enrollment;
        const personalInfoData = payloadState.personalInfo;
        const authRepData = payloadState.authRep;

        /** Filter out undefined values or REGEX MATCH WEIRD??  */
        const newregex: RegExp = new RegExp('^[0-9]*a?$');
        // Removing the blank values and invalid keys
        if (enrollmentData) {
            for (const [key, value] of Object.entries(enrollmentData)) {
                if (key === undefined || String(key).match(newregex) || value === '' || key === '') {
                    delete enrollmentData[key];
                }
            }
        }
        if (authRepData) {
            for (const [key, value] of Object.entries(authRepData)) {
                if (key === undefined || String(key).match(newregex) || value === '' || key === '') {
                    delete authRepData[key];
                }
            }
        }
        // Removing the blank values
        if (personalInfoData) {
            for (const [key, value] of Object.entries(personalInfoData)) {
                if (value === '') {
                    delete personalInfoData[key];
                }
            }
        }


        payloadState.personalInfo = payloadState.personalInfo || personalInfoData || {};
        payloadState.personalInfo.firstName = payloadState.personalInfo.firstName || (personalInfoData && personalInfoData.firstName);
        payloadState.personalInfo.middleInitial = payloadState.personalInfo.middleInitial || (personalInfoData && personalInfoData.middleInitial);
        payloadState.personalInfo.lastName = payloadState.personalInfo.lastName || (personalInfoData && personalInfoData.lastName);
        payloadState.personalInfo.county = zipcountyState.county.county;
        payloadState.personalInfo.countyCode = zipcountyState.county.code;
        payloadState.personalInfo.state = zipcountyState.county.state;
        payloadState.personalInfo.zipCode = zipcountyState.zipCode;

        payloadState.personalInfo.city = payloadState.personalInfo.city && payloadState.personalInfo.city.trim();

        payloadState['firstName'] = payloadState.personalInfo.firstName || (personalInfoData && personalInfoData.firstName);
        payloadState['lastName'] = payloadState.personalInfo.lastName || (personalInfoData && personalInfoData.lastName);

        if (enrollmentData && enrollmentData.effectiveDate) {
            payloadState.enrollment.effectiveDate = this.dateUtility.getEffectiveDate(enrollmentData.effectiveDate);
        }
    }

    private getInsuranceInfoStateValues(payloadState) {
        if (payloadState && payloadState.insuranceInfo) {
            for (const [key, value] of Object.entries(payloadState.insuranceInfo)) {
                if (value === '') {
                    delete payloadState.insuranceInfo[key];
                }
            }
            this.setDateOrRemoveKey(payloadState.insuranceInfo, 'startDate');
            this.setDateOrRemoveKey(payloadState.insuranceInfo, 'endDate');
            this.setDateOrRemoveKey(payloadState.insuranceInfo, 'otherPolicyCoverageStartDate');
            this.setDateOrRemoveKey(payloadState.insuranceInfo, 'otherPolicyCoverageEndDate');
        }
    }

    // TODO - I think keys are automatically removed now so this might be unnecessary, have not confirmed though
    private setDateOrRemoveKey(obj: any, key: string) {
        if (obj[key]) {
            obj[key] = this.dateUtility.getDateAsFormattedString(obj[key], 'MM/DD/YYYY');
        }
        else {
            delete obj[key];
        }
    }

    private getPrepopulatedDataForPlanChange(payloadState) {
        // To load plan change data
        const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');

        payloadState['personalInfo']['firstName'] = prePopulateData.prepopulatedFields.memberLookup.FIRSTNAME;
        payloadState['personalInfo']['lastName'] = prePopulateData.prepopulatedFields.memberLookup.LASTNAME;
        payloadState['personalInfo']['personalPhoneNumber'] = prePopulateData.prepopulatedFields.memberLookup.HOMEPHONE;
        payloadState['personalInfo']['dob'] = prePopulateData.prepopulatedFields.memberLookup.BIRTHDATE;
        payloadState['personalInfo']['gender'] = prePopulateData.prepopulatedFields.memberLookup.GENDER;
        payloadState['enrollment']['medicareNumber'] = prePopulateData.prepopulatedFields.memberLookup.HICNUMBER;

        // Only overwrite address info if we are not doing an address change with this plan change
        if (payloadState.personalInfo.changeAddress !== 'yes') {
            payloadState['personalInfo']['addressLine1'] = prePopulateData.prepopulatedFields.memberLookup.PERMSTREET1;
            payloadState['personalInfo']['addressLine2'] = prePopulateData.prepopulatedFields.memberLookup.PERMSTREET2;
            payloadState['personalInfo']['city'] = prePopulateData.prepopulatedFields.memberLookup.PERMCITY;
            payloadState['personalInfo']['state'] = prePopulateData.prepopulatedFields.memberLookup.PERMSTATE;
            payloadState['personalInfo']['zipCode'] = prePopulateData.prepopulatedFields.memberLookup.PERMZIP;
            payloadState['personalInfo']['county'] = prePopulateData.prepopulatedFields.memberLookup.PERMCOUNTYNAME;
        }
    }

    /** PRODUCT AGNOSTIC */
    /** Sets submission status - IN PROGRESS */
    private async generatePreSubmissionSavePayload(isPlanChange: boolean): Promise<EnrollPayloadSaveRequest> {
        let payload: EnrollPayloadSaveRequest = await this.generateEnrollmentSubmissionPayload(isPlanChange, false) as EnrollPayloadSaveRequest;
        payload.submitStatus = APP_STATUS.IN_PROGRESS;
        return payload;
    }

    /** PRODUCT AGNOSTIC */
    /** Sets submission status - SUBMIT */
    private async generateFinalSubmitPayload(isPlanChange: boolean, isSimplifiedEnrollment: boolean): Promise<EnrollPayloadSubmitRequest> {
        let payload: EnrollPayloadSubmitRequest = await this.generateEnrollmentSubmissionPayload(isPlanChange, isSimplifiedEnrollment) as EnrollPayloadSubmitRequest;
        payload.submitStatus = APP_STATUS.SUBMITTED;
        return payload;
    }

    /** PRODUCT AGNOSTIC */
    /** Force user to login when they want to save */
    async savePayload(saveForLaterPageUrl: string, forgotPwdUrl: string, regUrl: string) {
        const planState: PlansStateStructure = this.reducerUtilityService.getState(PLAN_STATE_NAME);
        const payload = await this.generatePreSubmissionSavePayload(planState?.isPlanChange);

        let basicUserInfo: BasicUserInfo = this.loggedInUserService.getUserData().basicUserInfo;

        const savePayloadSecure = async () => {
            try {
                const selectedPlan = this.planUtilityService.getSelectedPlan(payload.productType);

                const response = await this.electionQuestionsService.submitApplication(payload, true);

                if (!(response instanceof HttpErrorResponse)) {

                    this.ngRedux.dispatch(saveApplicationSubmissionInfo({
                        appId: response.appTrackingId,
                        submittedDate: this.dateUtility.getTodayAsMoment().format('MM/DD/YYYY hh:mm:ss A'),
                        submittedPlan: selectedPlan,
                        submittedApplicantName: payload.personalInfo.firstName + ' ' + payload.personalInfo.lastName,
                        submittedEffectiveDate: payload.enrollment.effectiveDate || payload.enrollment.coverageDate,
                        saveElectionAppIn: payload.enrollment.saveElectionAppIn
                    }));

                    const alertDuration = 3000; // ms

                    this.snackBar.open(`Successfully saved application.`, 'OK', {
                        duration: alertDuration,
                        panelClass: 'positive-panel-class'
                    });

                    setTimeout(() => {
                        this.windowLocationService.goToUrl(saveForLaterPageUrl);
                    }, alertDuration);
                }

            } catch (e) {
                console.error(e);
            }
        }


        if (!basicUserInfo) {

            // In case we need to register
            this.registrationService.setRegistrationCompleteUrl(window.location.pathname + window.location.search);

            const saveForLaterLoginModal = 'saveForLaterLoginModal';
            const dialogRef = this.matDialog.open(LoginPageComponent, {
                id: saveForLaterLoginModal,
                maxHeight: '100vh',
                maxWidth: '650px',
                data: {
                    producerLandingPageUrl: null,
                    memberLandingPageUrl: null,
                    consumerLandingPageUrl: null,
                    forgotPasswordUrl: forgotPwdUrl,
                    registrationStartUrl: this.registrationService.getRegistrationStartUrl()
                }
            });

            /** On Successful Login - submit */
            (this.matDialog.getDialogById(saveForLaterLoginModal).componentInstance as LoginPageComponent)
                .closeEmitter
                .subscribe(async x => {
                    dialogRef.close();
                    basicUserInfo = this.loggedInUserService.getUserData().basicUserInfo;

                    if (basicUserInfo) {
                        await savePayloadSecure();
                    }
                });

        } else {
            await savePayloadSecure();
        }

    }

    async submitPayload(confirmationPageUrls: ConfirmationPageUrls, isPlanChange?: boolean, isSimplifiedEnrollment?: boolean): Promise<FormError> {
        const planState: PlansStateStructure = this.reducerUtilityService.getState(PLAN_STATE_NAME);
        const payload = await this.generateFinalSubmitPayload(isPlanChange, isSimplifiedEnrollment);
        const selectedPlan = this.planUtilityService.getSelectedPlan(payload.productType);
        let formErr: FormError;

        if (planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_ADVANTAGE) {
            formErr = this.medicareSubmitService.validateMandatoryFields(payload, planState.activeProductGroup);
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN) {
            formErr = this.pdpSubmitService.validateMandatoryFields(payload, planState.activeProductGroup);
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.MEDIGAP
            || planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT) {
            formErr = this.medigapSubmitService.validateMandatoryFields(payload, planState.activeProductGroup);
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
            formErr = this.whbSubmitService.validateMandatoryFields(payload, planState.activeProductGroup);
        } else if (planState.activeProductGroup === PRODUCT_GROUPS.OFF_EXCHANGE) {
            formErr.valid = true;
        }

        if (!formErr.valid) {
            return formErr;
        }

        // If the user somehow skipped the agency/NPN screen, we need to validate that here
        // and prompt them to enter their info before they submit
        if (this.commonUtilityService.isAgent() && (!payload.agentInfo.agencyId || !payload.agentInfo.npnNumber)) {
            let agencyDetails: BaseAgency = await new Promise((resolve, reject) => {
                this.matDialog.open(ProducerChangeAgencyModalComponent, {
                    disableClose: true,
                    data: {
                        lob: this.reducerUtilityService.getApplicationStates()[LOB_STATE_NAME].lob,
                        disableChangeOnPaths: [],
                        modalTitle: 'Missing Agency Details',
                        modalDesc: 'We are missing your agency details, please provide them here to submit your app.',
                        enrollmentSubmitMode: true,
                        stayOnPage: true
                    }
                }).afterClosed().subscribe((val) => {
                    resolve(val);
                });
            });

            // In case something happens where we get here and we still don't have any details (ex: session timeout popup closes both windows)
            if (!agencyDetails) {
                return {valid: false, fieldName: 'agency'};
            }

            Object.assign(payload.agentInfo, {
                producerId: agencyDetails.npnNo,
                producerNumber: agencyDetails.npnNo,
                agencyNumber: agencyDetails.agencyId,
                agencyId: agencyDetails.agencyId,
                npnNumber: agencyDetails.npnNo,
                agencyName: agencyDetails.agencyName,
                producerUserId: agencyDetails.npnNo,
            });
        }

        const basicUserInfo: BasicUserInfo = this.loggedInUserService.getUserData().basicUserInfo;
        let secureService = false;
        if (basicUserInfo) {
            secureService = true;
        }

        try {
            const response = await this.electionQuestionsService.submitApplication(
                payload,
                secureService
            );
            if (!(response instanceof HttpErrorResponse)) {

                let confirmationData: EnrollmentAppStateStructure = {
                    appId: response.appTrackingId,
                    submittedDate: this.dateUtility.getTodayAsMoment().format('MM/DD/YYYY hh:mm:ss A'),
                    submittedPlan: selectedPlan,
                    submittedApplicantName: payload.personalInfo.firstName + ' ' + payload.personalInfo.lastName,
                    submittedEffectiveDate: payload.enrollment.effectiveDate || payload.enrollment.coverageDate,
                    saveElectionAppIn: payload.enrollment.saveElectionAppIn
                };

                // backup data we need here
                sessionStorage.setItem('confirmationBackup', JSON.stringify(confirmationData));

                this.ngRedux.dispatch(saveApplicationSubmissionInfo(confirmationData));

                if (planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_ADVANTAGE) {
                    this.windowLocationService.goToUrl(confirmationPageUrls.maConfirmationPageUrl);
                } else if (planState.activeProductGroup === PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN) {
                    this.windowLocationService.goToUrl(confirmationPageUrls.pdpConfirmationPageUrl);
                } else if (planState.activeProductGroup === PRODUCT_GROUPS.MEDIGAP
                    || planState.activeProductGroup === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT) {
                    this.windowLocationService.goToUrl(confirmationPageUrls.medigapConfirmationPageUrl);
                } else if (planState.activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
                    this.windowLocationService.goToUrl(confirmationPageUrls.whbConfirmationPageUrl);
                } else {
                    this.windowLocationService.goToUrl(confirmationPageUrls.confirmationPageUrl);
                }
                return formErr;
            }
        } catch (e) {
            formErr.valid = false;
            return formErr;
        }
    }

    async getDrxData(selectedPlan: Product<PlanAttributes, SummaryView>) {
        // todo - what to do if service fails ?? gasp - Parent wraps this call in try/catch so it will fail silently for now

        // these states will be empty if user never navigated to plan details page
        this.ngRedux.dispatch(selectPlanForDRX(selectedPlan as MedicareAdvantage_and_PDP_Product));
        this.ngRedux.dispatch(planDetailsByPlanId(selectedPlan.attributes.PLAN_ID));

        await this.drxService.updatePlanDetails();

        const drxStateUpdated: DRXStateStructure = this.reducerUtilityService.getState('DrxServiceData');
        return drxStateUpdated.drxSingleProductResponse;
    }
}

